import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import AboutPage from "@/pages/About";

export const Route = createFileRoute("/$lang/a-propos")({
  head: ({ params }) => pageHead(params.lang, "about"),
  component: AboutPage,
});
